/**
 * @requires Messages
 */
class Submit {
    /**
     * Constructor
     * @param {Element} formElement
     */
    constructor(formElement) {
        this.formElement = formElement;
        this.endpoint = this.formElement.action;
        this.method = this.formElement.method;

        this.overlayElement = this.formElement.closest('.overlay');

        this.formElement.Submit = this;

        this.registerEvents();
    }


    /**
     * Request init template
     * @return {Object}
     */
    get requestInitTemplate() {
        return {
            method: 'post', // only support for post method for now
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin'
        }
    };


    /**
     * Register events
     */
    registerEvents() {
        this.formElement.addEventListener('submit', (e) => {
            e.preventDefault();
            this.processSubmit(e);
        });
    }


    /**
     * Process submit
     */
    processSubmit() {
        if (!this.formElement.checkValidity()) return;

        // disable all submit inputs / buttons
        Array.from(this.formElement.elements).forEach((element) => {
            if (element.type === 'submit') element.disabled = true;
        });

        let requestInit = Object.assign({}, this.requestInitTemplate);
        requestInit.body = new FormData(this.formElement);

        this.formElement.classList.add('submit--loading');

        fetch(this.endpoint, requestInit)
            .then((response) => response.json())
            .then((response) => {
                this.updateForm();
                this.processResponse(response);
            })
            .catch((e) => {
                this.updateForm();
                console.log(e);
            });
    }




    /**
     * Update form after submit
     * Sets up the participating elements
     * It would be more appropriate to put this in a finally statement for the
     * Promise returned by fetch, but it doesn't support Edge 17, so we must do
     * it manually for now
     */
    updateForm() {
        // re-enable all submit inputs / buttons
        Array.from(this.formElement.elements).forEach((element) => {
            if (element.type == 'submit') element.disabled = false;
        });
    }

    /**
     * Process response
     * @param {Object} response
     */
    processResponse(response) {
        this.formElement.classList.remove('submit--loading');

        let validationErrors = response.validation || response.errors;
        if (validationErrors) {
            for (let fieldName in validationErrors) {
                let fieldElement = this.formElement.querySelector('[name="' + fieldName + '"]');
                if (!fieldElement) continue;

                let validationMessages = (Array.isArray(validationErrors[fieldName])) ? validationErrors[fieldName].join(' / ') : validationErrors[fieldName];
                this.showValidationError(fieldElement, validationMessages);
            }
        }

        if (response.redirectUrl) {
            location.href = response.redirectUrl;
        }
    }

    /**
     * Show validation error
     * @param {Element} fieldElement
     * @param {String} errorMessage
     */
    showValidationError(fieldElement, errorMessage) {
        if (this.formElement.Validation) {
            this.formElement.Validation.showMessage(fieldElement, errorMessage);
        } else {
            fieldElement.setCustomValidity(errorMessage);
            fieldElement.reportValidity();
        }
    }
};

let submit = (function() {
    document.body.addEventListener('submit', delegate('[data-submit]', function(e) {
        e.preventDefault();

        if (e.delegateTarget.Submit) {
            return;
        }

        new Submit(e.delegateTarget);
        e.delegateTarget.Submit.processSubmit(e);
    }));
})();
